export const FORM_ERROR_KEY = '_form'

export type FormErrors = Record<string, string[]>

export abstract class Form<TDto extends object> {
  abstract toDto(): TDto

  protected serverFields(): Record<string, string> {
    return {}
  }

  mapServerErrors(errors: FormErrors): FormErrors {
    const fields = this.serverFields()
    const result: FormErrors = {}

    for (const [key, messages] of Object.entries(errors)) {
      const root = key.split('.')[0] ?? key
      const field =
        fields[key] ??
        fields[root] ??
        (Object.hasOwn(this, key) ? key : Object.hasOwn(this, root) ? root : FORM_ERROR_KEY)

      result[field] = [...(result[field] ?? []), ...messages]
    }

    return result
  }
}

declare module '@vue/reactivity' {
  export interface RefUnwrapBailTypes {
    form: Form<object>
  }
}
